import deleteIdOfLiaisonsTarif from '@/services/catalogue/deleteIdOfLiaisonsTarif';

export default function formatageProduitAssocie(produit, periode) {
  const isLoc = !!(produit.produitLocation);
  const newProduct = {
    divers: !isLoc,
    location: isLoc,
    quantite: isLoc ? produit.produitLocation.quantite : produit.produitDivers.quantite,
    uniteVente: isLoc ? produit.produitLocation.uniteVente : produit.produitDivers.uniteVente,
    prixUnitaire: isLoc ? produit.produitLocation.prixUnitaire : produit.produitDivers.prixUnitaire,
    liaisonsTarif: produit.liaisonsTarif,
    libelle: produit.libelle + ' - ' + produit.reference,
    dateDebut: periode.dateDebut,
    dateFin: periode.dateFin,
    produitEnfantId: produit.id,
    archive: false,
    produitEnfant: {
      supportCommercial: produit.supportCommercial,
      produitDivers: produit.produitDivers,
    },
    isAlreadySelect: false,
  };
  deleteIdOfLiaisonsTarif(produit);
  return newProduct;
}
